
        export const version = '6.7.7';
        export const buildTimestampIso = '2023-02-22T20:47:59.667Z';
        export const versionCheck = '6.7.7,2023-02-22T20:47:58.780Z';
        export const curEnv = 'staging-app';
        export const hash = '584db43dc';
        export const commit = "[spa] 3058: Tidy up included asset list, meta data";
        export const commitTimestampIso = '2023-02-22T12:46:46-08:00';
        